import React, { useEffect, useState, useContext } from "react";
import ClientForm from "../../components/create/ClientForm";
import PositionForm from "../../components/create/PositionForm";
import ResponsiveAppBar from "../../components/navbar/responsiveAppBar";
import { Container, Grid } from "@mui/material";
import { Typography } from "@mui/material";
import Title from "../../components/Title";

import { ToastProvider } from "react-toast-notifications";
import { ConfirmProvider } from "material-ui-confirm";
export default function CreatePage() {
  useEffect(() => {
    // console.log("useffect in create");
  }, []);


  return (
    <div>
      <ResponsiveAppBar />
      <Grid
        component="main"
        sx={{
          // flexGrow: 1,
          py: 4,
          // height: "100vh",
          overflow: "auto",
          backgroundColor: "#F3F4F6",
        }}
      >
            <Container maxWidth={"lg"}>
              <Grid container rowSpacing={6}>
                <Grid item sx={{ width: "100%" }}>
                  <Grid item sx={{ ml: 1 }}>
                    <Typography
                      component="h2"
                      variant="h5"
                      color="primary"
                      gutterBottom
                    >
                      Create Client
                    </Typography>
                  </Grid>
                  <ClientForm />
                </Grid>
                <Grid item sx={{ width: "100%" }}>
                  <Grid item sx={{ ml: 1 }}>
                    <Typography
                      component="h2"
                      variant="h5"
                      color="primary"
                      gutterBottom
                    >
                      Create Position
                    </Typography>
                  </Grid>
                  <PositionForm />
                </Grid>
              </Grid>
            </Container>
      </Grid>
    </div>
  );
}
